export default [
  {
    path: '',
    name: 'transactions',
    component: () => import(/* webpackChunkName: "transactions-history" */ '~/views/TransactionsHistory/TransactionsHistory.vue'),
    meta: {
      header: { type: 'slot', name: 'HeaderTransactions' },
    },
  },


];
